// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import "./sass/index.scss";
import 'viewport-extra';
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import '@auroratide/typewritten-text/lib/style.css';
import '@auroratide/typewritten-text/lib/define.js';


/* ----------------------------------
ローディング
---------------------------------- */

const loading = document.getElementById('loading');
const firstView = document.getElementById('firstView');
const firstViewLogo = document.querySelector('.firstView_logo');
const firstViewCopy = document.querySelector('.firstView_copy');

const bodyWrap = document.getElementsByTagName("body");


/* 読み込み完了 */
window.addEventListener('load', stopload);

/* 6秒経ったら強制的にロード画面を非表示にする */
setTimeout(stopload,6000, '');

const fvLeft = new Swiper('.firstView_slider_left .swiper', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 2000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
});
fvLeft.autoplay.stop();
const fvRight = new Swiper('.firstView_slider_right .swiper', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 2000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
});
fvRight.autoplay.stop();

/* ロード画面を非表示にする処理 */
function stopload(){
  document.body.classList.add('is-loaded');
  if(firstView) {
    firstView.classList.add('is-loaded');
    // firstViewLogo.classList.add('is-animated');
    // firstViewCopy.classList.add('is-animated');
    fvLeft.autoplay.start();
    setTimeout(() => {
      fvRight.autoplay.start();
    }, 2500);

  }

  if(loading.classList.contains('is-change')) {
    loading.classList.remove('is-change');
  }
  bodyWrap[0].classList.add("timer-zero");

  // 1秒後に実行
  setTimeout(() => {
    bodyWrap[0].classList.add("timer-one");
  }, 1200);

  // 5秒後に実行
  setTimeout(() => {
    bodyWrap[0].classList.add("timer-two");
  }, 2000);

  // 5秒後に実行
  setTimeout(() => {
    bodyWrap[0].classList.add("timer-three");
  }, 2400);

}


/* ----------------------------------
画面高さをCSS変数に代入（100vh用）
---------------------------------- */

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  ScrollTrigger.refresh();
}

let vw = window.innerWidth;

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
    // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  setFillHeight();
});

// 初期化
setFillHeight();

// 対象となる要素をすべて変数へ格納
const animeTargets = document.querySelectorAll(".animation");

// オプション
// root : nullの場合はブラウザのビューポート
// rootMargin : 0とすると↑で指定したルート要素と交差した瞬間（1pxでも）発火。今回のように-50%とすると対象要素がルート要素であるブラウザのビューポートの半分のところで交差したら発火となる。ルート要素を基準としたオプション。
// threshold : 閾値（しきいち）。どのくらい交差したら発火するかを指定する。0とすれば交差した瞬間に発火。対象要素を基準としたオプション。
// rootMarginとthresholdで交差してから（可視範囲に入ってから）どの程度で発火するかを調整できるということ。
const animeOption = {
  root: null,
  rootMargin: "-20% 0px",
  threshold: 0
};

// 対象となるターゲットが可視範囲に入ったらis-animatedというクラスを付与する関数
const targets = (entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add("is-animated");
      if(entry.target.hasAttribute('paused')) {
        entry.target.start();
      }
      animeObserver.unobserve(entry.target);
    }
  });
};

// 可視範囲に入ったら実行する関数targetsとfadeOptionを引数にしてIntersectionObserverコンストラクターを呼び出し
const animeObserver = new IntersectionObserver(targets, animeOption);

// animeTargetsのすべての要素を監視印象に登録
animeTargets.forEach((target) => {
  animeObserver.observe(target);
});

const header = document.querySelector('.siteHead');



document.querySelectorAll(".nav-toggle").forEach(function(el, i){
  el.addEventListener('click',function(e){
    const gNav = document.querySelector('.gNav');
    const gNavOverlay = document.querySelector('.gNav_overlay');
    const toggleBtn = document.querySelector('.gNav_toggle');
    let bodyStyle = getComputedStyle(document.body);
    gNav.classList.toggle('is-active');
    toggleBtn.classList.toggle('is-active');
    gNavOverlay.classList.toggle('is-open');
    header.classList.toggle('is-open');
    if (bodyStyle.overflow == 'visible') {
      document.body.style.overflow = 'hidden';
    }else if (bodyStyle.overflow == 'hidden') {
      document.body.style.overflow = 'visible';
    }
  })
})

// メニューを開く関数
const slideDown = function(el) {
  el.style.height = 'auto'; //いったんautoに
  let h = el.offsetHeight; //autoにした要素から高さを取得
  el.style.height = h + 'px';
  el.animate({ //高さ0から取得した高さまでのアニメーション
    height: [ 0, h + 'px' ]
  }, {
    duration: 300, //アニメーションの時間（ms）
  });
  el.style.height = 'auto'; //ブラウザの表示幅を途中で閲覧者が変えた時を考慮してautoに戻す
};
// メニューを閉じる関数
const slideUp = function(el) {
  let h = el.offsetHeight;
  el.style.height = h + 'px';
  el.animate({
    height: [ h + 'px', 0 ]
  }, {
    duration: 300,
  });
  el.style.height = 0;
};
let activeIndex = null; //開いているアコーディオンのindex



document.querySelectorAll(".gNav_list_item-parent").forEach(function(accordionBtn, i){
  accordionBtn.addEventListener('click',function(e){
    activeIndex = i; //クリックされたボタンを把握
    accordionBtn.classList.toggle('is-active');
    const content = accordionBtn.querySelector('.gNav_list_item_sub');
    if(accordionBtn.classList.contains('is-active')){
      slideDown(content); //クラス名がactive（＝閉じていた）なら上記で定義した開く関数を実行
    }else{
      slideUp(content); //クラス名にactiveがない（＝開いていた）なら上記で定義した閉じる関数を実行
    }
    //スクロール制御のために上位階層ulのクラス名を変える
    // let container = accordion.closest('.scroll-control'); // クラス名がscroll-controlである近傍の要素
    // if(accordionBtn.parentNode.classList.contains('active') == false && container !== null ){
    //   container.classList.remove('active')
    // }else if (container !== null){
    //   container.classList.add('active')
    // }

  })
})



if(firstView) {
  const headHiddenOptions = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "0px", // ビューポートの中心を判定基準にする
    threshold: 0 // 閾値は0
  };
  const fvObserver = new IntersectionObserver(doHidden, headHiddenOptions);
  fvObserver.observe(document.querySelector('.firstView'));

  function doHidden(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        header.classList.add('in-firstView');
      } else {
        header.classList.remove('in-firstView');
      }
    });
  };
}

if(document.querySelector(".index_recruit")) {
  const changeBgOptions = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
    threshold: 0 // 閾値は0
  };
  const infoBgChange = new IntersectionObserver(infoBg, changeBgOptions);
  const infoSection = document.querySelectorAll(".index_recruit");
  infoSection.forEach(function (value) {
    infoBgChange.observe(value);
  })

  function infoBg(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.body.classList.add('in-recruit');
      } else {
        document.body.classList.remove('in-recruit');
      }
    });
  };
}


const smoothScrollTrigger = document.querySelectorAll('.smoothScroll');
for (let i = 0; i < smoothScrollTrigger.length; i++){
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = 0;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
}

// const PageTopBtn = document.getElementById('page-top');
// PageTopBtn.addEventListener('click', () =>{
//   window.scrollTo({
//     top: 0,
//     behavior: 'smooth'
//   });
// });




// typeBtnクラスを持つ要素を全て取得
const typeBtns = document.querySelectorAll('.typeBtn');

// 実行済みフラグを持つ配列
const executedArray = new Array(typeBtns.length).fill(false);

// 実行する関数
function executeOnce(event) {
  const targetIndex = Array.from(typeBtns).indexOf(event.currentTarget);
  if (!executedArray[targetIndex]) {
    const typeBtn_type = event.currentTarget.querySelector('typewritten-text');
    typeBtn_type.start();
    executedArray[targetIndex] = true;
  }
}

// 全てのtypeBtnクラスを持つ要素にマウスオーバーのイベントリスナーを追加
typeBtns.forEach((typeBtn, index) => {
  typeBtn.addEventListener('mouseenter', executeOnce);
});

if (document.querySelector('.tabs')) {
  const tabs = document.querySelector('.tabs');
  const tabItems = tabs.querySelectorAll('.tabs__item');
  const tabPanes = tabs.querySelectorAll('.tabs__pane');

  function switchTab(tab) {
    // タブの切り替え処理
    for (let i = 0; i < tabItems.length; i++) {
      if (tabItems[i] === tab) {
        tabItems[i].classList.add('tabs__item--active');
        tabPanes[i].classList.add('tabs__pane--active');
      } else {
        tabItems[i].classList.remove('tabs__item--active');
        tabPanes[i].classList.remove('tabs__pane--active');
      }
    }
  }

  // 初期表示
  switchTab(tabItems[0]);

  // イベントリスナーの設定
  tabs.addEventListener('click', function(event) {
    const clickedTab = event.target.closest('.tabs__item');
    if (!clickedTab) return;

    event.preventDefault();

    // タブの切り替え
    switchTab(clickedTab);
  });
}

if (document.querySelector('.faq')) {
  document.addEventListener("DOMContentLoaded", () => {
    setUpAccordion();
  });

  /**
   * ブラウザの標準機能(Web Animations API)を使ってアコーディオンのアニメーションを制御します
   */
  const setUpAccordion = () => {
    const details = document.querySelectorAll(".js-details");
    const RUNNING_VALUE = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
    const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

    details.forEach((element) => {
      const summary = element.querySelector(".js-summary");
      const content = element.querySelector(".js-content");

      summary.addEventListener("click", (event) => {
        // デフォルトの挙動を無効化
        event.preventDefault();

        // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
        if (element.dataset.animStatus === RUNNING_VALUE) {
          return;
        }

        // detailsのopen属性を判定
        if (element.open) {
          // アコーディオンを閉じるときの処理
          // アイコン操作用クラスを切り替える(クラスを取り除く)
          element.classList.toggle(IS_OPENED_CLASS);

          // アニメーションを実行
          const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
          // アニメーション実行中用の値を付与
          element.dataset.animStatus = RUNNING_VALUE;

          // アニメーションの完了後に
          closingAnim.onfinish = () => {
            // open属性を取り除く
            element.removeAttribute("open");
            // アニメーション実行中用の値を取り除く
            element.dataset.animStatus = "";
          };
        } else {
          // アコーディオンを開くときの処理
          // open属性を付与
          element.setAttribute("open", "true");

          // アイコン操作用クラスを切り替える(クラスを付与)
          element.classList.toggle(IS_OPENED_CLASS);

          // アニメーションを実行
          const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
          // アニメーション実行中用の値を入れる
          element.dataset.animStatus = RUNNING_VALUE;

          // アニメーション完了後にアニメーション実行中用の値を取り除く
          openingAnim.onfinish = () => {
            element.dataset.animStatus = "";
          };
        }
      });
    });
  }

  /**
   * アニメーションの時間とイージング
   */
  const animTiming = {
    duration: 400,
    easing: "ease-out"
  };

  /**
   * アコーディオンを閉じるときのキーフレーム
   */
  const closingAnimKeyframes = (content) => [
    {
      height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
      opacity: 1,
    }, {
      height: 0,
      opacity: 0,
    }
  ];

  /**
   * アコーディオンを開くときのキーフレーム
   */
  const openingAnimKeyframes = (content) => [
    {
      height: 0,
      opacity: 0,
    }, {
      height: content.offsetHeight + 'px',
      opacity: 1,
    }
  ];
}

